module.exports = __webpack_public_path__ + "media/images/google-play-e48edb3edb3db4d1c5e6a33d019a2669.webp";